module.exports = __webpack_public_path__ + "img/maroon2.21a9e6a8.png";